export const GET_SHOP = 'GET_SHOP';
export const GET_SHOP_SUCCEEDED = 'GET_SHOP_SUCCEEDED';
export const GET_SHOP_FAILED = 'GET_SHOP_FAILED';
export const GET_SHOP_LIST = 'GET_SHOP_LIST';
export const GET_SHOP_LIST_SUCCEEDED = 'GET_SHOP_LIST_SUCCEEDED';
export const GET_SELECTED_COMPANY_INFO = 'GET_SELECTED_COMPANY_INFO';
export const GET_COMPANY_INFO_SUCCEEDED = 'GET_COMPANY_INFO_SUCCEEDED';
export const GET_FEEDBACK = 'GET_FEEDBACK';
export const GET_FEEDBACK_SUCCEEDED = 'GET_FEEDBACK_SUCCEEDED';

export const GET_GROUP_FILTER_OPTIONS = 'GET_GROUP_FILTER_OPTIONS';
export const GET_GROUP_FILTER_OPTIONS_SUCCEEDED = 'GET_GROUP_FILTER_OPTIONS_SUCCEEDED';
export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';

export const GET_LOYALTY_INFORMATION = 'GET_LOYALTY_INFORMATION';
export const GET_LOYALTY_INFORMATION_SUCCEEDED = 'GET_LOYALTY_INFORMATION_SUCCEEDED';

export const LOAD_SHOP_ID = 'LOAD_SHOP_ID';

export const GET_PROMOTIONS = 'GET_PROMOTIONS';
export const SET_PROMOTIONS = 'SET_PROMOTIONS';
